module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/concept_testing_catering-69a44ba2515b5ce4ec05b6f80050629f.png";